module.exports = __webpack_public_path__ + "img/sifrarnik.4a485431.svg";